<template>
    <div style="">
        <div style="flex:1; display:flex; flex-direction: column; ">
            <div style="flex:1;"></div>
            <div style="display:grid; place-items: center;">
                <div style="background-color: white; width:350px; height:360px; padding:20px; border-radius:24px; ">
                    <div style="font-weight:bold; font-size:16px;" @click="closeModal">닫기</div>
                    <div style="text-align:center; margin-top:10px;">
                        <img :src="require('@/assets/img/popup_position_pro_ground.jpg')" style="width:160px;">
                    </div>
                    <div style="margin-top:20px; color:#210F03; font-size:20px; line-height:34px; font-weight:bold;text-align:center;">포지션 찾기 PRO를 진행하시기 전에<br>축구 질문 딱 한 가지만 작성해주세요.</div>
                    <div style="display:grid; place-items: center;">
                        <div style="height:40px; width:222px; display:grid;place-items: center; background-color: black; color:white; font-weight:bold; font-size:14px; border-radius:20px; margin-top:20px;" @click="showWriteForm">지금 바로 질문하기</div>
                    </div>

                </div>
            </div>
            <div style="height:50px;"></div>
        </div>
        <LearnSoccerWriteForm :topics="[]" :refresh="closeModal" :isShowWriteForm="isShowWriteForm" :closeWriteForm="() => {isShowWriteForm = false}" :formType="'SKILL'"></LearnSoccerWriteForm>
    </div>
</template>

<script>
    import LearnSoccerWriteForm from "../../soccerhowmain/LearnSoccerWriteForm";

    export default {
        name: "PopupBeforePositionPro",
        components: {LearnSoccerWriteForm},
        data(){
            return {
                isShowWriteForm : false,
            }
        },
        methods : {
            closeModal(){
                this.$GlobalStore.closeLastModal();
            },
            showWriteForm(){
                this.isShowWriteForm = true;
            }
        }
    }
</script>

<style scoped>

</style>